import { Component, Inject, ViewChild } from '@angular/core';
import { AnteprimaDoppiaMaterialitaSuveyComponent } from './anteprima-doppia-materialita-suvey/anteprima-doppia-materialita-suvey.component';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import {
  DoppiaMaterialitaService,
  DoppiaSurvey,
} from 'src/app/services/doppia-materialita/doppia-materialita.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize, firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-dialog-doppia-materialita-compila-survey',
  standalone: false,

  templateUrl: './dialog-doppia-materialita-compila-survey.component.html',
  styleUrl: './dialog-doppia-materialita-compila-survey.component.scss',
})
export class DialogDoppiaMaterialitaCompilaSurveyComponent {
  @ViewChild('surveyDoppiaMat') surveyComponent!: AnteprimaDoppiaMaterialitaSuveyComponent;

  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public struttraSurvey: DoppiaSurvey | undefined = undefined;
  public landingPage: string = '';
  public datiSurvey: boolean = false;
  public erroreDatiSurvey: string = '';

  constructor(
    /* private doppiaMaterialitaService: doppiaMaterialitaService */
    private readonly doppiaMaterialitaService: DoppiaMaterialitaService,
    private readonly utilityService: UtilityService,
    public dialogRef: MatDialogRef<DialogDoppiaMaterialitaCompilaSurveyComponent>,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      idDoppiaMaterialita: string;
      idCategoriaStakeholder: string;
      idStakeholder: string;
      idSurvey: string;
      idSurveyCompilato: string;
    },
  ) {}

  ngAfterViewInit(): void {
    this.surveyInterna();
    this.getLandingPage();
  }

  async salva() {
    if (this.doppiaMaterialitaService.isElementoNonCompilato(this.surveyComponent.datiSurvey)) {
      return this.utilityService.openSnackBar('Rispondi a tutti gli IRO', '', {
        duration: 2000,
        panelClass: ['red-snackbar'],
      });
    }

    const dialog = this.utilityService.openDialog({
      titolo: 'Compilazione Terminata',
      descrizione: 'Le risposte non saranno modificabili. Confermi?',
      bottoni: [
        {
          nome_btn: 'No',
          id_btn: 'N',
        },
        {
          nome_btn: 'Si',
          id_btn: 'S',
        },
      ],
    });

    const valDialog = await firstValueFrom(dialog.beforeClosed());
    if (valDialog === 'N') {
      return;
    }
    this.spinnerOver.show();

    this.surveyComponent.datiSurvey.tipo = 'DOPPIA_SURVEY';

    return this.doppiaMaterialitaService
      .postDatiDoppiaSurvey(
        this.data.idDoppiaMaterialita,
        this.data.idStakeholder,
        this.data.idSurvey,
        this.surveyComponent.datiSurvey,
      )
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (result: any) => {
          this.utilityService.openSnackBar('Salvataggio effettuato ', '', {
            duration: 2000,
            panelClass: ['success-snackbar'],
          });
          this.dialogRef.close();
        },
        error: (err: any) => {
          console.error('Errore durante il salvataggio della survey', err);
          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: 'Errore nel salvataggio della survey',
            bottoni: [{ nome_btn: 'Chiudi' }],
          });
        },
      });
  }

  surveyInterna() {
    this.spinnerOver.show();
    //survey compilata
    if (this.data.idSurveyCompilato) {
      this.doppiaMaterialitaService
        .getDoppiaSurveyCompilata(this.data.idDoppiaMaterialita, this.data.idSurveyCompilato)
        .subscribe({
          next: (result) => {
            this.struttraSurvey = result;
            this.spinnerOver.hide();

            this.datiSurvey = true;
          },
          error: (err: any) => {
            this.spinnerOver.hide();
            console.error('errore get survey', err.error.message);
          },
        });
    } else {
      //survey non compilata
      this.doppiaMaterialitaService
        .getDatiDoppiaSurvey(this.data.idDoppiaMaterialita, this.data.idCategoriaStakeholder)
        .subscribe({
          next: (result: any) => {
            this.struttraSurvey = result?.doppiaSurvey;
            this.spinnerOver.hide();

            this.datiSurvey = true;
          },
          error: (err: any) => {
            this.spinnerOver.hide();
            console.error('errore get survey', err.error.message);
            this.erroreDatiSurvey = err.error.message;
          },
        });
    }
  }

  public getLandingPage() {
    this.doppiaMaterialitaService.getTemplateMailSurvey(this.data.idDoppiaMaterialita).subscribe({
      next: (template) => {
        this.landingPage = template.landingPage || '';
      },
      error: (err: any) => {
        console.error('Errore durante la chiamata al servizio', err);
      },
    });
  }
}
